var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/SideNav/SideNav.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/SideNav/SideNav.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"SideNav SideNav--isHidden ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"subUrl")) {
output += " SideNav--sub SideNav--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"url"), env.opts.autoescape);
output += " SideNav--subPage";
;
}
output += "\"\n     ";
if(runtime.contextOrFrameLookup(context, frame, "activeNav")) {
output += "data-navtype=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"url"), env.opts.autoescape);
output += "\"";
;
}
output += ">\n    <div class=\"SideNav-desc\">\n        <span class=\"SideNav-descContent\">Сделки с недвижимостью</span>\n    </div>\n    <div class=\"SideNav-content\">\n        <div class=\"SideNav-nav\">\n            ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "nav");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("item", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                ";
if(runtime.memberLookup((t_7),"withSub")) {
output += "\n                    <div class=\"SideNav-item SideNav-item--withSub ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"url") == runtime.memberLookup((t_7),"url")) {
output += "SideNav-item--isActive";
;
}
output += "\"\n                         data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"url"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_7),"text")), env.opts.autoescape);
output += "</div>\n                ";
;
}
else {
output += "\n                    <div class=\"SideNav-item ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"url") == runtime.memberLookup((t_7),"url")) {
output += "SideNav-item--isActive";
;
}
output += "\"><a\n                            class=\"u-Route\" href=\"";
output += runtime.suppressValue((lineno = 15, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:" + runtime.memberLookup((t_7),"url")])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_7),"text")), env.opts.autoescape);
output += "</a></div>\n                ";
;
}
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n            <div class=\"SideNav-close\">";
output += runtime.suppressValue((lineno = 18, colno = 63, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["x",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "</div>\n        </div>\n        <div class=\"SideNav-subnav\">\n            ";
frame = frame.push();
var t_12 = runtime.contextOrFrameLookup(context, frame, "subnav");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += "\n                <div class=\"SideNav-item SideNav-item--sub ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"subUrl") == runtime.memberLookup((t_13),"url")) {
output += "SideNav-item--isActive";
;
}
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeNav")),"subUrl")) {
output += " SideNav-item--isVisible";
;
}
output += "\"\n                     data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((t_13),"url"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_13),"text")), env.opts.autoescape);
output += "</div>\n            ";
;
}
}
frame = frame.pop();
output += "\n            <div class=\"SideNav-active SideNav-active--subnav\"></div>\n            <div class=\"SideNav-close\">";
output += runtime.suppressValue((lineno = 27, colno = 63, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["x",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
output += "</div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/SideNav/SideNav.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SideNav/SideNav.jinja
// module id = 92
// module chunks = 0